export default __webpack_public_path__ + "static/image2-9e86290bf1f3fb8fd698037992641381.jpeg";